import { AnySelection } from '@d3fc/d3fc-series';
import { annotationSvgGridline } from '@d3fc/d3fc-annotation';

export default function gridlines(yTicks: number, isBps?: boolean) {
    const svgGridLines = annotationSvgGridline().xTicks(0).yTicks(yTicks);

    if (isBps) {
        svgGridLines.yDecorate((sel: AnySelection<SVGElement, number>) => {
            sel.classed('bps-zero-line', (d: number) => d === 0);
        });
    }

    return svgGridLines;
}

export function autoYGridlines(isBps?: boolean) {
    const svgGridLines = annotationSvgGridline().xTicks(0);

    if (isBps) {
        svgGridLines.yDecorate((sel: AnySelection<SVGElement, number>) => {
            sel.classed('bps-zero-line', (d: number) => d === 0);
        });
    }

    return svgGridLines;
}
